import MatchRowTeaser from 'app/components/matchRow/teaser/MatchRowTeaser';
import React from 'react';
import { MatchesView as Container } from 'app/components/competitionModule/matches/commonStyles';
export default function MatchesView(_ref) {
  let {
    matches
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "MatchesView",
    "data-sentry-source-file": "MatchesView.tsx"
  }, matches.map(matchData => /*#__PURE__*/React.createElement(MatchRowTeaser, {
    key: matchData.slug,
    match: matchData
  })));
}